<template>
  <v-btn
    v-on="$listeners"
    v-bind="$attrs"
    :class="{
      'ui-btn': !lg && !xl,
      'ui-btn-lg': lg,
      'ui-btn-xl': xl,
      'btn-off': off,
      'btn-solid': !outlined,
      'btn-outlined': outlined,
    }">
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  name: "Button",

  props: {
    off: {
      type: Boolean,
      required: false,
      default: false,
    },
    lg: {
      type: Boolean,
      required: false,
      default: false,
    },
    xl: {
      type: Boolean,
      required: false,
      default: false,
    },
    outlined: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>
